import PaymentMethodModal from './components/PaymentMethodModal';
import ThreeDSModal from './components/ThreeDSModal';

export const modals = {
  SELECT_PAYMENT_METHOD: PaymentMethodModal,
  THREEDS_MODAL: ThreeDSModal
};

export default modals;
